import React, {useState} from "react";
import SearchTable from "../../../primer/Search-Table";
import {getObjectFromArrayOfObjects} from "../../../../_helpers/helperFunctions";
import {useSelector} from "react-redux";

const SearchFixedAssets = () => {
    const fixedAssetsSettings = useSelector((state) => state.FIXED_ASSETS.fixedAssetsSettings);

    const fixedAssetsCategoryOptions = [
        {value: "", label: "Κενό"},
        ...fixedAssetsSettings.categories.map((o) => {
            return {
                value: o._id,
                label: o.name,
            }
        })
    ]

    const searchFilters = {
        filters: [
            {
                name: "identifier",
                label: "Όνομα/Κωδικός Παγίου",
                type: "input",
                mdWidth: 3,
            },
            {
                name: "category",
                label: "Κατηγορία",
                type: "dropdown",
                options: fixedAssetsCategoryOptions,
                mdWidth: 2,
            },
            {
                name: "acquisitionCost_from",
                label: "Κόστος κτήσης από",
                type: "input",
                mdWidth: 2,
            },
            {
                name: "acquisitionCost_to",
                label: "Κόστος κτήσης έως",
                type: "input",
                mdWidth: 2,
            },
            {
                name: "notes",
                label: "Σημειώσεις / Παρατηρήσεις",
                type: "input",
                mdWidth: 3,
            },
        ],
        actions: ["quick-edit", "delete"],
    }

    const scColumns = [
        {
            name: "Όνομα Παγίου",
            field: "name",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: "Κωδικός Συστήματος",
            field: "systemCode",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: "Χειροκίνητος Κωδικός",
            field: "manualCode",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: "Κατηγορία",
            field: "categoryName",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: "Ημερομηνία από",
            field: "dateFrom",
            editable: false,
            inputType: {
                type: 'datebox',
            }
        },
        {
            name: "Κόστος κτήσης",
            field: "acquisitionCost",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: "Αποσβεσμένο Ποσό",
            field: "accumulatedDepreciation",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: "Υπόλοιπο",
            field: "balance",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
    ]

    const [tableColumns, setTableColumns] = useState(scColumns.slice());

    // It will hide or show the table columns for search table.
    const handleColumnShowHide = (field) => {
        let tempTc = tableColumns.slice();
        let object = getObjectFromArrayOfObjects(tempTc, field, 'field')
        const index = tempTc.findIndex((item) => field === item.field);
        if (object.length > 0) {
            tempTc[index].hiddenColumn = !object['0'].hiddenColumn;
            setTableColumns(tempTc);
        }
    }

    return (
        <React.Fragment>
            <SearchTable
                tableName="Fixed Assets Search"
                key={"Fixed Assets Search"}
                hideYearFilter={true}
                allowPagination={true}
                allowToggleColumns={true}
                showDummyData={false}
                allowPrintResults={true}
                dataEndpoint={"/fixedassets/search-fixed-assets"}
                exportFileName={"Πάγια"}
                columns={tableColumns}
                toggleColumns={handleColumnShowHide}
                allowSelectionCheckbox={false}
                data={[]}
                filtersConfig={searchFilters}
            />
        </React.Fragment>
    )
}

export default SearchFixedAssets;
